import React from 'react';
import { Row, Col, Card, CardBody } from 'reactstrap';

/**
 * Dashboard Summary Cards Component
 * Displays 4 summary cards showing service statistics
 * Used at the top of the Service Monitoring Dashboard
 *
 * Props:
 * - services: Array of ServiceConfigDto objects
 *
 * Cards:
 * 1. Total Services (blue)
 * 2. Running Services (green)
 * 3. Stopped Services (yellow)
 * 4. Services With Errors (red)
 */
const DashboardSummaryCards = ({ services }) => {
  // Calculate statistics from services array
  const totalServices = services.length;
  const runningServices = services.filter(s => s.isRunning === 1).length;
  const stoppedServices = services.filter(s => s.isRunning === 0).length;
  const servicesWithErrors = services.filter(s =>
    s.lastExecutionStatus === 'Failed' || s.lastExecutionStatus === 'Error'
  ).length;

  return (
    <Row className="summary-cards mb-4">
      {/* Total Services Card */}
      <Col md={3} sm={6} className="mb-3">
        <Card className="border-0 shadow-sm h-100">
          <CardBody>
            <div className="d-flex justify-content-between align-items-center">
              <div>
                <h6 className="text-muted mb-1 text-uppercase" style={{ fontSize: '0.75rem' }}>
                  Total Services
                </h6>
                <h2 className="mb-0 font-weight-bold">{totalServices}</h2>
              </div>
              <div className="text-primary" style={{ fontSize: '2.5rem', opacity: 0.3 }}>
                <i className="fa fa-server"></i>
              </div>
            </div>
          </CardBody>
        </Card>
      </Col>

      {/* Running Services Card */}
      <Col md={3} sm={6} className="mb-3">
        <Card className="border-0 shadow-sm bg-success text-white h-100">
          <CardBody>
            <div className="d-flex justify-content-between align-items-center">
              <div>
                <h6 className="mb-1 text-uppercase" style={{ fontSize: '0.75rem', opacity: 0.8 }}>
                  Running
                </h6>
                <h2 className="mb-0 font-weight-bold">{runningServices}</h2>
              </div>
              <div style={{ fontSize: '2.5rem', opacity: 0.3 }}>
                <i className="fa fa-play-circle"></i>
              </div>
            </div>
          </CardBody>
        </Card>
      </Col>

      {/* Stopped Services Card */}
      <Col md={3} sm={6} className="mb-3">
        <Card className="border-0 shadow-sm bg-warning h-100">
          <CardBody>
            <div className="d-flex justify-content-between align-items-center">
              <div>
                <h6 className="mb-1 text-uppercase" style={{ fontSize: '0.75rem', opacity: 0.8 }}>
                  Stopped
                </h6>
                <h2 className="mb-0 font-weight-bold">{stoppedServices}</h2>
              </div>
              <div style={{ fontSize: '2.5rem', opacity: 0.3 }}>
                <i className="fa fa-stop-circle"></i>
              </div>
            </div>
          </CardBody>
        </Card>
      </Col>

      {/* Errors Card */}
      <Col md={3} sm={6} className="mb-3">
        <Card className="border-0 shadow-sm bg-danger text-white h-100">
          <CardBody>
            <div className="d-flex justify-content-between align-items-center">
              <div>
                <h6 className="mb-1 text-uppercase" style={{ fontSize: '0.75rem', opacity: 0.8 }}>
                  With Errors
                </h6>
                <h2 className="mb-0 font-weight-bold">{servicesWithErrors}</h2>
              </div>
              <div style={{ fontSize: '2.5rem', opacity: 0.3 }}>
                <i className="fa fa-exclamation-triangle"></i>
              </div>
            </div>
          </CardBody>
        </Card>
      </Col>
    </Row>
  );
};

export default DashboardSummaryCards;
